import { ExpandedTableRow } from './ExpandedTableRow';
import { Item } from '../../types/item.types';
import { TableBody as SkapaTableBody } from '@ingka/table';
import { SubItem } from '../../types/sub-item.types';
import { Table } from '@tanstack/react-table';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/core/theme';
import { useTableDataState } from '../../state/table-data.state';

type ExpandedTableBodyProps = {
   instance: Table<SubItem>;
   parentIndex: number;
   parentItem: Item;
   onViewItem: (item: SubItem) => void;
   viewedItems: Set<number>;
};

export const ExpandedTableBody = ({ instance, parentIndex, parentItem, onViewItem, viewedItems }: ExpandedTableBodyProps) => {
   const rowModel = instance.getRowModel();
   const columns = instance.getVisibleFlatColumns();
   const isInactiveHidden = useTableDataState(state => state.query.inactivatedRowsHidden || false);

   const visibleRows = rowModel.rows.filter(row =>
      !(isInactiveHidden && !(row.original as SubItem).active)
   );

   return (
      <SkapaTableBody style={{ tableLayout: 'fixed' }}>
         {visibleRows.length > 0
            ? visibleRows.map((row) => {
               const color: string = (row.original as SubItem).active
                  ? theme.colors.text.primary
                  : theme.colors.text.tertiary;

               return (
                  <ExpandedTableRow
                     key={row.id}
                     row={row}
                     parentIndex={parentIndex}
                     parentItem={parentItem}
                     color={color}
                     onClick={() => onViewItem(row.original)}
                     viewedItems={viewedItems}
                  />
               );
            })
            : (
               <tr>
                  <StyledNoDataTableData colSpan={columns.length}>No results</StyledNoDataTableData>
               </tr>
            )
         }
      </SkapaTableBody>
   );
};

const StyledNoDataTableData = styled.td`
   text-align: center;
   color: ${theme.colors.text.tertiary};
`;
